import { AppSecurityKey } from "./AppSecurityKey";

export const ObservationSessionMode = Object.freeze({
    ADD: {name: "Add New Observation", appSecurityKey: AppSecurityKey.ADD_OBSERVATION},
    COPY: {name: "Copy Observation", appSecurityKey: AppSecurityKey.COPY_OBSERVATION},
    RESUME: {name: "Resume Suspended Observation", appSecurityKey: AppSecurityKey.RESUME_OBSERVATION},
    UPDATE: {name: "Update Existing Observation", appSecurityKey: AppSecurityKey.UPDATE_OBSERVATION},
    DUPLICATE: {name: "Duplicate Existing Observation", appSecurityKey: AppSecurityKey.DUPLICATE_OBSERVATION},
    READONLY: {name: "View Existing Observation in read-only mode", appSecurityKey: AppSecurityKey.VIEW_READONLY_OBSERVATION},
    NONE: {name: "Mode not Defined", appSecurityKey: AppSecurityKey.NONE}
  });